export const completedFinalReviewLabel = {
  tableTitle: "완료된 총평",
  apiRequestFailMessage:
    "요청을 처리할 수 없습니다. 잠시 후 다시 시도해주세요.",
};

export const finalReviewStatusLabel = {
  tableTitle: "총평 현황",
  apiRequestFailMessage:
    "요청을 처리할 수 없습니다. 잠시 후 다시 시도해주세요.",
};

export const editFinalReviewLabel = {
  cardTitle: "총평하기",
  titles: {
    paper: "투고 정보",
    reviewers: "심사위원 현황",
    result: "게재 여부",
    comment: "총평 내용",
  },
  buttons: {
    pdf: "pdf",
    close: "닫기",
    temporarySave: "임시저장",
    submit: "제출",
  },
  apiRequestFailMessage:
    "요청을 처리할 수 없습니다. 잠시 후 다시 시도해주세요.",
};

export const showFinalReviewLabel = {
  cardTitle: "총평 내용",
  titles: {
    paper: "투고 정보",
    reviewers: "심사위원 의견",
    result: "게재 여부",
    comment: "총평 내용",
  },
  buttons: {
    pdf: "pdf",
    close: "닫기",
  },
  apiRequestFailMessage:
    "요청을 처리할 수 없습니다. 잠시 후 다시 시도해주세요.",
};

export const paperPublishManagementLabel = {
  tableTitle: "게재 대기 논문",
  apiRequestFailMessage:
    "요청을 처리할 수 없습니다. 잠시 후 다시 시도해주세요.",
};
